import { Component, Renderer2 } from '@angular/core';
import { FIREBASE_CONFIG } from 'src/environments/environment';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/analytics'
import 'firebase/database';

import { Title } from '@angular/platform-browser';
import { AltomateService } from './altomate.service';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  public isRestricted = false;

  constructor(private titleService: Title, private renderer: Renderer2, private altomateService: AltomateService) {
    console.log('AppComponent constructor started');
    const host = window.location.host;

    console.log(host);

    // domain restriction check
    if (host === 'cosec-bbs.softon.io') {
      this.isRestricted = true;
    }

    firebase.initializeApp(FIREBASE_CONFIG);
    firebase.database().ref('settings/bitrixUrl').once('value', setts => {
      console.log('Host detected:', host);

      let settingArray = Object.values(setts.val() || {})
      console.log('Available settings in DB:', settingArray.map(s => s['subdomain']));

      let settings = settingArray.find(g => {
        const subdomain = g['subdomain'] || '';
        return subdomain === host || host.startsWith(subdomain + '.');
      });

      // <----- FusionETA - Alvin (6 April 2026) - Fallback for localhost/test environments to "testing" - Start ----->
      if (!settings && (host.includes('localhost') || host.includes('127.0.0.1') || host.includes('web.app') || host.includes('firebaseapp.com'))) {
        console.log('No direct match found for host, attempting fallback to "testing" configuration');
        settings = setts.val()?.['testing'] || settingArray.find(g => g['subdomain']?.includes('testing'));
      }
      // <----- FusionETA - Alvin (6 April 2026) - Fallback for localhost/test environments to "testing" - End ----->

      if (!settings) {
        console.error('CRITICAL: No matching configuration found for host:', host);
      } else {
        console.log('Configuration matched:', settings);
      }

      this.changeWebsiteMetadata(settings?.['title'] || '', settings?.['logo'] || '');
      this.altomateService.bitrixUrl = (settings?.['bitrixUrl'] || '').toString()
      this.altomateService.reponsible_person = (settings?.['responsible'] || '').toString()
      this.altomateService.cosecid = (settings?.['cosecid'] || '').toString()
      this.altomateService.isLoading = false
      this.altomateService.company_logo = settings?.['logo'] || ''

      console.log('Bitrix Configuration Loaded:', {
        url: this.altomateService.bitrixUrl,
        responsible: this.altomateService.reponsible_person,
        cosec: this.altomateService.cosecid
      });
    })

  }

  changeWebsiteMetadata(title, logo) {
    this.titleService.setTitle(title)
    let link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || this.renderer.createElement('link');
    link.type = 'image/png';
    link.rel = 'icon';
    link.href = logo;
    this.renderer.appendChild(document.head, link);
  }

}
